module.exports = __webpack_public_path__ + "img/Chevron-left.c1747d23.svg";